var map = {
	"./Capitolo_2_01_confidato.mp4": 5246,
	"./Capitolo_2_01_non_confidato.mp4": 3546,
	"./Capitolo_2_02_con Vis.mp4": 9023,
	"./Capitolo_2_02_opporsi a Vis.mp4": 1141,
	"./Capitolo_2_03_confidarsi con Giovanni.mp4": 3644,
	"./Capitolo_2_04_messaggi con gli altri.mp4": 1489,
	"./Capitolo_2_05_ mex corretti.mp4": 3423,
	"./Capitolo_2_05_ mex non  corretti.mp4": 3323,
	"./Capitolo_2_06_mex a Vis.mp4": 3648,
	"./Capitolo_2_07_messaggio audio(fine cap 2).mp4": 9028,
	"./Capitolo_2_ALESSANDRO.mp4": 82
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2993;